import {
    CO_GET_QUALITYRATING_LISTING,
    CO_GET_QUALITYRATING_LISTING_SUCCESS,
    CO_GET_QUALITYRATING_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    qualityRating: null,
  }
  
  const coQualityRating = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_QUALITYRATING_LISTING:
        state = {
          ...state,
          loading: true,
          qualityRating: action.payload,
        }
        break
      case CO_GET_QUALITYRATING_LISTING_SUCCESS:
        state = { ...state, loading: false, qualityRating: action.payload }
        break
      case CO_GET_QUALITYRATING_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coQualityRating
  